import React from 'react';
import { Typography, Button, Paper, Box } from '@mui/material';

interface Move {
    moveNumber: number;
    white: string;
    black?: string;
}

interface MovesSectionProps {
    moveList: Move[];
    copyMovesToClipboard: () => void;
    copyButtonText: string;
    chessboardWidth: number;
}

const MovesSection: React.FC<MovesSectionProps> = ({ moveList, copyMovesToClipboard, copyButtonText, chessboardWidth }) => {
    return (
        <Paper elevation={0} sx={{ p: 2, m: 0, maxHeight: 400, width: chessboardWidth, overflowY: 'auto', backgroundColor: '#fff', border: '1px solid #e0e0e0', borderRadius: 2 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5, borderBottom: '1px solid #eee', pb: 1 }}>
                <Typography variant="subtitle1" fontWeight="bold" color="text.secondary">
                    Move History
                </Typography>
                <Button
                    variant="text"
                    size="small"
                    onClick={copyMovesToClipboard}
                    sx={{ color: '#375643', fontSize: '0.75rem', textTransform: 'none' }}
                >
                    {copyButtonText}
                </Button>
            </Box>

            <Box sx={{ display: 'grid', gridTemplateColumns: 'auto 1fr 1fr', gap: 1, fontSize: '0.9rem' }}>
                {moveList.map((movePair, index) => (
                    <React.Fragment key={index}>
                        <Typography variant="body2" color="text.secondary" sx={{ minWidth: 24, textAlign: 'right', mr: 1, alignSelf: 'center' }}>
                            {movePair.moveNumber}.
                        </Typography>
                        <Box sx={{
                            backgroundColor: index % 2 === 0 ? '#f5f5f5' : 'transparent',
                            p: 0.5,
                            borderRadius: 1,
                            textAlign: 'center',
                            cursor: 'default',
                            '&:hover': { backgroundColor: '#e0e0e0' }
                        }}>
                            {movePair.white}
                        </Box>
                        <Box sx={{
                            backgroundColor: index % 2 === 0 ? '#f5f5f5' : 'transparent',
                            p: 0.5,
                            borderRadius: 1,
                            textAlign: 'center',
                            cursor: 'default',
                            '&:hover': { backgroundColor: '#e0e0e0' }
                        }}>
                            {movePair.black ? movePair.black : ''}
                        </Box>
                    </React.Fragment>
                ))}
                {moveList.length === 0 && (
                    <Typography variant="body2" color="text.secondary" sx={{ gridColumn: '1 / -1', textAlign: 'center', py: 2, fontStyle: 'italic' }}>
                        No moves yet.
                    </Typography>
                )}
            </Box>
        </Paper>
    );
};

export default MovesSection;
